// extracted by mini-css-extract-plugin
module.exports = {"cardImage":"CardImage_cardImage__1uLGy","cardBtn":"CardImage_cardBtn__2abSu"};